export default "__VITE_ASSET__DU8aAhyL__"